import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import DemoMode from '@/components/DemoMode';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useDownloadHistory } from '@/context/DownloadHistoryContext';
import { setDownloadHistoryCallback } from '@/utils/exportUtils';

export default function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { addEntry } = useDownloadHistory();

  useEffect(() => {
    setDownloadHistoryCallback(addEntry);
    return () => setDownloadHistoryCallback(null);
  }, [addEntry]);

  return (
    <div className="flex h-screen bg-[#080D1A] overflow-hidden">
      {/* Mobile backdrop */}
      {mobileMenuOpen && (
        <div
          data-testid="mobile-backdrop"
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />
        <ScrollArea className="flex-1">
          <main className="p-3 sm:p-4 lg:p-6 min-h-full page-transition" data-testid="main-content" key={location.pathname}>
            <Outlet />
          </main>
        </ScrollArea>
      </div>
      <DemoMode />
    </div>
  );
}
